<!-- template html -->
<template>
    <div v-if="isLoading" class="gt-groupcard-loader">
        <img :src="$getAssetUrlPlugin('siteres/gt-loader.gif')" alt="Loading" />
        <p>
            {{loadingText}}
        </p>
    </div>
</template>
<!-- template html -->
<!-- script -->
<script>
    export default {
        name: 'GenericLoader',
        props: {
            loadingText: String,
            isLoading: Boolean
        }
    }
</script>
<!-- script -->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>